import { __extends, __makeTemplateObject, __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

/**
 * Providence Microcopy component.
 * @see {@link https://providence.fmr.com/components/microcopy/microcopy.html|Microcopy documentation}
 */
var PvdMicrocopy = /** @class */ (function (_super) {
    __extends(PvdMicrocopy, _super);
    function PvdMicrocopy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PvdMicrocopy.prototype, "hasText", {
        // #endregion
        // #region private methods
        get: function () {
            return !!this.pvdText || this.isSlotUsed();
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    // #region LitElement lifecycles
    PvdMicrocopy.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-microcopy-root"),
            modifierPrefix: 'pvd-microcopy',
            modifiers: [],
        };
        return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      <div class=\"", "\" id=\"", "\">\n        ", "\n      </div>\n    "], ["\n      <div class=\"", "\" id=\"", "\">\n        ", "\n      </div>\n    "])), getClassName(classMap), l(this.pvdId), this.hasText
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject([" <p class=\"pvd-microcopy__microcopy\"><s-slot>", "</s-slot></p> "], [" <p class=\"pvd-microcopy__microcopy\"><s-slot>", "</s-slot></p> "])), this.pvdText) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject([" <s-slot></s-slot> "], [" <s-slot></s-slot> "]))));
    };
    //#region Component configuration
    PvdMicrocopy.componentName = 'microcopy';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdMicrocopy.prototype, "pvdId", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-text' }),
        __metadata("design:type", String)
    ], PvdMicrocopy.prototype, "pvdText", void 0);
    return PvdMicrocopy;
}(PvdSlotifyBaseComponent));
var templateObject_1, templateObject_2, templateObject_3;

export { PvdMicrocopy };
